import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_MENU_INDEX } from "../actions/returnType";
import {
  ACTIVE_MENU,
  CITY_LIST,
  DISTRICT_LIST,
  DIVISION_LIST,
  PRIVACY_POLICY,
  STATE_LIST,
  TERMS_CONDITION,
} from "../actions/types";
import * as commonApis from "../apis/commonApis.js";

export function* stateListWorker(action) {
  try {
    const res = yield call(commonApis.stateListApi, {});
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* districtListWorker(action) {
  try {
    const res = yield call(commonApis.districtListApi, {
      state_id: action.state_id,
    });
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* cityListWorker(action) {
  try {
    const res = yield call(commonApis.cityListApi, {
      state_id: action.state_id,
      district_id: action.district_id,
    });
    // console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* divisionListWorker(action) {
  try {
    const res = yield call(commonApis.divisionListApi);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* privacyPloicyWorker(action) {
  try {
    const res = yield call(commonApis.privacyPloicyApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* termsConditionWorker(action) {
  try {
    const res = yield call(commonApis.termsConditionApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* activeMenuWorker(action) {
  try {
    console.log("active", action);
    yield put({ type: UPDATE_MENU_INDEX, index: action.index });
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* stateListWatcher() {
  yield takeLatest(STATE_LIST, stateListWorker);
}

export function* districtListWatcher() {
  yield takeLatest(DISTRICT_LIST, districtListWorker);
}

export function* cityListWatcher() {
  yield takeLatest(CITY_LIST, cityListWorker);
}

export function* divisionistWatcher() {
  yield takeLatest(DIVISION_LIST, divisionListWorker);
}

export function* activeMenuWatcher() {
  yield takeLatest(ACTIVE_MENU, activeMenuWorker);
}

export function* privacyPloicyWatcher() {
  yield takeLatest(PRIVACY_POLICY, privacyPloicyWorker);
}

export function* termsConditionWatcher() {
  yield takeLatest(TERMS_CONDITION, termsConditionWorker);
}
